import { render, staticRenderFns } from "./SelectionButton.vue?vue&type=template&id=50ef235d&scoped=true&"
import script from "./SelectionButton.vue?vue&type=script&lang=js&"
export * from "./SelectionButton.vue?vue&type=script&lang=js&"
import style0 from "./SelectionButton.vue?vue&type=style&index=0&id=50ef235d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef235d",
  null
  
)

export default component.exports